"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const embed_1 = require("@gr4vy/embed");
const lodash_isequal_1 = __importDefault(require("lodash.isequal"));
const react_1 = __importStar(require("react"));
const Gr4vyEmbed = (0, react_1.memo)((0, react_1.forwardRef)((props, instanceRef) => {
    const ref = (0, react_1.useRef)();
    const instance = (0, react_1.useRef)();
    (0, react_1.useEffect)(() => {
        if (ref.current) {
            instance.current = (0, embed_1.setup)(Object.assign(Object.assign({}, props), { element: ref.current }));
        }
    }, [ref, props]);
    (0, react_1.useImperativeHandle)(instanceRef, () => ({
        submit: () => instance.current.submit(),
    }));
    return react_1.default.createElement("div", { ref: ref });
}), lodash_isequal_1.default);
Gr4vyEmbed.displayName = 'Gr4vyEmbed';
exports.default = Gr4vyEmbed;
//# sourceMappingURL=Gr4vyEmbed.js.map